export default __webpack_public_path__ + "static/media/IconUserManagement.624c31d6.svg";